import { render } from "./ContractForm.vue?vue&type=template&id=e0b969c6"
import script from "./ContractForm.vue?vue&type=script&lang=js"
export * from "./ContractForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__